import { render, staticRenderFns } from "./citizenship_addresses.vue?vue&type=template&id=c532b0ee&"
import script from "./citizenship_addresses.vue?vue&type=script&lang=js&"
export * from "./citizenship_addresses.vue?vue&type=script&lang=js&"
import style0 from "./citizenship_addresses.vue?vue&type=style&index=0&id=c532b0ee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports